import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';
import axios from 'axios';
import Lightbox from 'react-image-lightbox';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';

import printerIcon from '../media/printIcon.png';
import recipesBG from '../media/recipespagebackground.jpg';


export default class Recipes extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {
      recipeList: [],
      lightboxOpen: false,
      lightboxIndexToOpen: 0
    };
  }

  componentWillMount() {
    this.setRecipeList();
  }

  setRecipeList = () => {
    axios.get('https://s3.amazonaws.com/pattersonmaplefarmsstorage/recipes/Recipes.json')
      .then(response => {
        this.setState({
          recipeList: response.data
        });
      })
      .catch(error => {
        console.log('Error fetching and parsing data', error);
      });
  }

  recipeClick = (recipeIndex) => {
    this.setState({ lightboxIndexToOpen: recipeIndex, lightboxOpen: true })
  }

  printInLightbox = () => {
    let recipePrintElement = document.getElementsByClassName("ril-image-current ril__image");
    let printArea = window.open('', 'PRINT', 'height=607,width=788');
    printArea.document.write('<html><head><title>' + document.title  + '</title>');
    printArea.document.write('</head><body >');
    //printArea.document.write('<h1>' + document.title  + '</h1>');
    printArea.document.write('</head><body >');
    printArea.document.write(`<img src='${this.state.recipeList[this.state.lightboxIndexToOpen].imgURL}'></img>`);
    printArea.document.write('</body></html>');
    printArea.document.close();
    printArea.focus();
    printArea.print();
    printArea.close();
  }

  render() {
    const RecipeView = this.state.recipeList.map((recipe, index, array) => {
      return <RecipeDiv key={index} 
        onClick={() => this.recipeClick(index)}>
          <p>
            {recipe.name}
          </p>
      </RecipeDiv>
    });
    const PrinterToolbarButton_ForLightBox = (
      <Button style={{width: "28px", height: "33px", cursor: "pointer", 
                    backgroundImage: `url(${printerIcon})`, backgroundPosition: "center", backgroundRepeat: "no-repeat"}} 
              src={require("../media/printIcon.png")}
              onClick={() => this.printInLightbox() } >
      </Button>
    );

    const RecipePrintView = ( <RecipePrintContainer>
        {this.state.lightboxOpen ? 
          <Lightbox id="lightboxID" mainSrc={this.state.recipeList[this.state.lightboxIndexToOpen].imgURL} 
            nextSrc={this.state.recipeList[(this.state.lightboxIndexToOpen + 1) % this.state.recipeList.length].imgURL}
            prevSrc={this.state.recipeList[(this.state.lightboxIndexToOpen + this.state.recipeList.length - 1) % this.state.recipeList.length ].imgURL}
            onCloseRequest={() => this.setState({lightboxOpen: false})} 
            onMovePrevRequest={ () => this.setState({ lightboxIndexToOpen: (this.state.lightboxIndexToOpen + this.state.recipeList.length - 1) % this.state.recipeList.length }) }
            onMoveNextRequest={ () => this.setState({ lightboxIndexToOpen: (this.state.lightboxIndexToOpen + 1) % this.state.recipeList.length }) } 
            imageTitle={ this.state.recipeList[this.state.lightboxIndexToOpen].name }
            toolbarButtons={[ PrinterToolbarButton_ForLightBox ]} />
          
        : ""
        }
      </RecipePrintContainer>
    );

    return (
    	<FluidContainer fluid>
        <Helmet>
          <title>Recipes - Patterson Maple Farms</title>
        </Helmet>
        <InternalContainer>
	        
      		{/*ExampleObject*/}
      		<h1>Outstanding Maple Recipes</h1>
          <p>
            We will periodically update the recipes with a variety of tastes. 
            Please try them and let us know what you think. If you have any
            creative ideas, we invite you to send them in for us to try.
          </p>

          {RecipeView}

          <ShopBookLink to="/Shop/books"><span>For more recipes, check out our own maple cookbook by clicking here!</span></ShopBookLink>
          <LeavesPic src={require("../media/leavespng1.png")}></LeavesPic>

          {RecipePrintView}
        </InternalContainer>
      </FluidContainer>
		);
	}
}

const LeavesPic = styled.img`
  width: 80px;
  float: right;
`;

const ShopBookLink = styled(Link)`
  display: block;
  margin: 40px 0 0 0;
  transition: all 0.5s;

  span { color: white!important; }
  :hover { text-decoration: none; transform: translateY(6px); }
`;

const RecipePrintContainer = styled(Container)` clear: both; `;

const RecipeDiv = styled.div`
  border-bottom: 2px solid white;
  cursor: pointer;
  margin-top: 50px;
  transition: all 0.5s;
  :hover { transform: translateY(6px); }

  p { margin: 0; }
`;

const FluidContainer = styled(Container)` 
  padding: 30px 0 20px 0!important;  
  background-image: url(${recipesBG}); 

`;
const InternalContainer = styled(Container)` 
  h1 { color: white; }  
  p { color: white; }

`;

//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
`;
*/



// WEBPACK FOOTER //
// ./src/pages/Recipes.js